import { Component, OnInit } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { MiscService } from '../../_service/misc.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LeadAssignmentSettingModalComponent } from '../../settings/lead-assignment-setting-modal/lead-assignment-setting-modal.component';

declare var $: any;
@Component({
  selector: 'app-lead-assignment-setting',
  templateUrl: './lead-assignment-setting.component.html',
  styleUrls: ['./lead-assignment-setting.component.css']
})
export class LeadAssignmentSettingComponent implements OnInit {
  circles=[];treatCategory=[];bds:[];
  constructor(private leadapi:LeadsService,private sharedapi:SharedService,public miscapi:MiscService,private dialog:MatDialog) { 
    this.getTreatmentCategory();
    this.getcircle();
  }

  ngOnInit(): void {
    
  }

  openBdsDialog(circle_id,catergory_id)
    {
        const dialogRef = this.dialog.open(LeadAssignmentSettingModalComponent, {
            width: '50%',
            data:{circle_id:circle_id,catergory_id:catergory_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

  async getTreatmentCategory()
  {
      await this.miscapi.getAssignTreat_Category().subscribe((data:any) => {
          if(data.status)
          {
            this.treatCategory = data.data;
          }else{
              this.treatCategory = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
  }


}
